// frontend/src/components/quizzes/QuizResultView.tsx

import { ActiveQuiz, QuizResult } from '../../types/quiz.types';
import { MathFormulaRenderer } from '../common/MathFormulaRenderer';

interface QuizResultViewProps {
  quiz: ActiveQuiz;
  result: QuizResult;
  onRetry: () => void;
  onNewQuiz: () => void;
}

function scoreColor(score: number): string {
  if (score >= 70) return 'var(--secondary)';
  if (score >= 40) return 'var(--accent)';
  return 'var(--danger)';
}

export function QuizResultView({ quiz, result, onRetry, onNewQuiz }: QuizResultViewProps) {
  return (
    <div className="quiz-container quiz-result">
      <div className="quiz-result-header">
        <div className="quiz-result-score" style={{ color: scoreColor(result.score) }}>
          %{result.score}
        </div>
        <p>
          {result.correctCount} / {result.totalCount} doğru cevap
        </p>
        <div className="quiz-result-xp">+{result.xpAwarded} XP kazandın! ⭐</div>
      </div>

      <div className="quiz-result-breakdown">
        {quiz.questions.map((q, i) => {
          const r = result.results.find((res) => res.questionId === q.id);
          if (!r) return null;
          return (
            <div key={q.id} className={`quiz-result-item ${r.correct ? 'correct' : 'wrong'}`}>
              <div className="quiz-result-item-header">
                <span>{r.correct ? '✅' : '❌'}</span>
                <div style={{ flex: 1 }}>
                  <strong>Soru {i + 1}:</strong> <MathFormulaRenderer text={q.question} />
                </div>
              </div>
              {!r.correct && (
                <div className="quiz-result-item-answer">
                  <strong>Doğru cevap:</strong> <MathFormulaRenderer text={r.correctAnswer} />
                </div>
              )}
              {r.explanation && (
                <div className="quiz-result-item-explanation">
                  💡 <strong>Çözüm & Açıklama:</strong> <MathFormulaRenderer text={r.explanation} />
                </div>
              )}
            </div>
          );
        })}
      </div>

      <div className="quiz-result-actions">
        <button type="button" className="lesson-btn secondary" onClick={onRetry}>
          🔄 Tekrar Çöz
        </button>
        <button type="button" className="lesson-btn primary" onClick={onNewQuiz}>
          🚀 Yeni Quiz
        </button>
      </div>
    </div>
  );
}

